import fukkuClasses from 'fukku/styles/classes.module.scss'
import text from 'fukku/styles/texts.module.scss'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useRef } from 'react'
import { cx } from 'utils/cx'
import styles from './ChatDialogSearchAddress.module.scss'

export const ChatDialogSearchAddress = ({
	onCancelSearchAddress,
}: { readonly onCancelSearchAddress: () => void }) => {
	const searchAddressTitleRef = useRef<HTMLParagraphElement>(null)
	const { t } = useLabels()

	useEffect(() => {
		searchAddressTitleRef.current?.focus()
	}, [])

	return (
		<>
			<button
				className={styles.overlay}
				onClick={onCancelSearchAddress}
				type='button'
			>
				<p className={fukkuClasses.srOnly}>
					{t('assistant.close.cancel.button')}
				</p>
			</button>
			<div className={styles.chatDialogSearchAddress}>
				<p
					className={cx(styles.exitTitle, text.uppercaseM)}
					tabIndex={-1}
					ref={searchAddressTitleRef}
				>
					{t('assistant.changeAddress.title')}
				</p>
			</div>
		</>
	)
}
